import {
  useFilterTags,
  useUrlFilterTagKeys,
  useUrlFilterTags,
} from "hooks/filterHooks";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export function TagKeyToIdGuard() {
  const { tagKey } = useUrlFilterTagKeys();
  const { data: tags } = useFilterTags();
  const { updateTags } = useUrlFilterTags();

  useEffect(() => {
    if (tagKey && tags) {
      const tag = tags.originalTags.find((tag) => tag.key === tagKey);
      if (tag) {
        updateTags(tag.id, true);
      }
    }
  }, [tagKey, tags, updateTags]);

  return (
    <Outlet
      context={{
        tags: {
          originalTags: tags?.originalTags || [],
          treeTags: tags?.treeTags || [],
        },
      }}
    />
  );
}
